import React from "react";
import {Area, DoopUser, ProjectMeta} from "./Interfaces/IDOOP";

export type DoopDataContextValue = {
    meta: ProjectMeta | null;
    users: DoopUser[];
    areas: Area[];
    loading: boolean;
    error: string;
    refresh: () => Promise<void>;
};

const defaultValue: DoopDataContextValue = {
    meta: null,
    users: [],
    areas: [],
    loading: false,
    error: "",
    refresh: async () => {},
};

export const DoopDataContext = React.createContext<DoopDataContextValue>(defaultValue);

export const useDoopData = () => React.useContext(DoopDataContext);
